<template>
  <div class="seller-main">
    <el-breadcrumb
      v-if="!hideBreadcrumb"
      separator-class="iconfont iconbreadcrumb-arrow"
      class="seller-main-breadcrumb">
      <i class="seller-main-breadcrumb-item-icon iconfont iconcrumbs-address" />
      <el-breadcrumb-item
        v-for="breadcrumbItem in breadcrumbData"
        :key="breadcrumbItem"
        class="seller-main-breadcrumb-item">
        <template>
          <span class="seller-main-breadcrumb-item-text">{{ breadcrumbItem }}</span>
        </template>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <router-view class="seller-main-container" />
  </div>
</template>

<script>
export default {
  name: 'seller-name',
  props: ['hideBreadcrumb'],
  mounted () {
    this.getBreadcrumbData(this.$route.path)
  },
  watch: {
    $route (to) {
      this.getBreadcrumbData(to.path)
    }
  },
  data () {
    return {
      breadcrumbData: [] // 面包屑数据
    }
  },
  methods: {
    /**
     * 从$route.fullPath中获取路径名
     * @param {String} routePath 当前的路径名
     */
    getBreadcrumbData (routePath) {
      // 初始化路径名数组
      this.breadcrumbData = []
      // 截取路径名，并去除空值
      const breadcrumbDataRAW = routePath.split('/').filter((el) => {
        return el !== ''
      })
      // 将转译好的路径名推入数组中
      for (let i = 0; i < breadcrumbDataRAW.length; i++) {
        this.breadcrumbData.push(
          this.breadcrumbTranslate(breadcrumbDataRAW[i])
        )
      }
    },

    /**
     * 路径名转译方法
     * @param {String} pathName 路径名
     * @returns {String} 对应的中文路径名
     */
    breadcrumbTranslate (pathName) {
      switch (pathName) {
        case 'dashboard':
          return '首页'
        case 'shop':
          return '店铺管理'
        case 'order':
          return '订单管理'
        case 'outbound':
          return '出库管理'
        case 'inbound':
          return '入库管理'
        case 'sku':
          return '商品管理'
        case 'warehouse':
          return '仓库管理'
        case 'store':
          return '库存管理'
        case 'detail':
          return '详情'
        default:
          return pathName.substring(0, 1).toUpperCase() + pathName.substring(1)
      }
    }
  }
}
</script>

<style lang="scss">
// 面包屑 start
.seller-main-breadcrumb {
  height: 46px;
  display: flex;
  align-items: center;
  padding: 3px 20px 0;
  border-bottom: solid 3px #68B0AB;
  box-sizing: border-box;
  .seller-main-breadcrumb-item-icon {
    color: #68B0AB;
    padding-right: 10px;
  }
  .seller-main-breadcrumb-item {
    .seller-main-breadcrumb-item-text {
      color: #4a4a4a;
    }
    &:last-child {
      .seller-main-breadcrumb-item-text {
        color: #006A71;
        font-weight: 600;
      }
    }
  }
  // 有效链接样式
  .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link {
    font-weight: 500;
    .seller-main-breadcrumb-item-text {
      cursor: pointer;
    }
    &:hover .seller-main-breadcrumb-item-text {
      text-decoration: underline;
    }
  }
  // 箭头
  .el-breadcrumb__separator {
    margin: 0 8px;
    color: #68B0AB;
    font-size: 12px;
  }
}
// 面包屑 end
</style>



// WEBPACK FOOTER //
// src/layout/component/main.vue